import {
  FETCH_PROPERTY_REQUEST,
  FETCH_PROPERTY_SUCCESS,
  FETCH_PROPERTY_FAILURE,
  FETCH_PROPERTIES_REQUEST,
  FETCH_PROPERTIES_SUCCESS,
  FETCH_PROPERTIES_FAILURE,
  FETCH_OPEN_HOUSES_REQUEST,
  FETCH_OPEN_HOUSES_SUCCESS,
  FETCH_OPEN_HOUSES_FAILURE,
  FETCH_WALKSCORE_SUCCESS
} from '../constants'

const initialState = {
  list: [],
  isLoadingList: true,
  results: 0,
  openHousesList: [],
  isLoadingOpenHouses: true,
  openHouseResults: 0,
  current: {},
  isLoadingCurrent: true,
  walkscore: {}
}

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_PROPERTY_REQUEST:
      return {
        ...state,
        current: {},
        isLoadingCurrent: true
      }
    case FETCH_PROPERTY_SUCCESS:
      return {
        ...state,
        current: action.property,
        isLoadingCurrent: false
      }
    case FETCH_PROPERTY_FAILURE:
      return {
        ...state,
        current: {},
        isLoadingCurrent: false
      }
    case FETCH_PROPERTIES_REQUEST:
      return {
        ...state,
        list: [],
        isLoadingList: true
      }
    case FETCH_PROPERTIES_SUCCESS:
      return {
        ...state,
        list: action.properties,
        isLoadingList: false,
        results: action.results
      }
    case FETCH_PROPERTIES_FAILURE:
      return {
        ...state,
        list: [],
        isLoadingList: false,
        results: 0
      }
    case FETCH_OPEN_HOUSES_REQUEST:
      return {
        ...state,
        openHousesList: [],
        isLoadingOpenHouses: true
      }
    case FETCH_OPEN_HOUSES_SUCCESS:
      return {
        ...state,
        openHousesList: action.properties,
        isLoadingOpenHouses: false,
        openHouseResults: action.results
      }
    case FETCH_OPEN_HOUSES_FAILURE:
      return {
        ...state,
        openHousesList: [],
        isLoadingOpenHouses: false,
        openHouseResults: 0
      }
    case FETCH_WALKSCORE_SUCCESS:
      return {
        ...state,
        walkscore: action.walkscore
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/properties.js